import React, { useState } from 'react'; 
import { withTranslation } from 'react-i18next'; 
import ModalBottomSheetUI from '../../../components/UI/ModalBottomSheetUI';
import { translate } from '../../../utils/util';

const ButtonsSubtitle = (props) => {
    const [info, setInfo] = useState({ data: [], preloader: true, open: false });

    const closeModal = () => {
        info.open = false;
        setInfo({ ...info });
    }
    return (
        <>
            <div style={{ float: 'right', marginRigth: '10px' }}>
                <i
                    className="material-icons"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        info.open = info.open ? false : true;
                        setInfo({ ...info })
                    }}>info
                </i>
            </div> 
            <ModalBottomSheetUI
                open={info.open}
                maxHeight="65%"
                onClose={closeModal}
                data={
                    <div
                        style={{ wordBreak: 'break-word', fontWeight: 'bold' }}
                        // key={`item-${item.shed} ${item.partNumberCode}`}
                        className="sixth-text-color">
                            <div style={{ display: 'flex', alignItems: 'center'}}>
                                <i className={`mdi mdi-36px mdi-layers-outline gray-text`} /> {translate('receipt-cim-pallet', 'physical-confirmation')}
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center'}}>
                                <i className={`mdi mdi-36px mdi-alpha-m-circle-outline gray-text`} /> {translate('massive-receipt', 'physical-confirmation')}
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center'}}>
                                <i className={`mdi mdi-36px mdi-package-variant-closed gray-text`} /> {translate('receipt-total', 'physical-confirmation')}
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center'}}>
                                <i className={`mdi mdi-36px mdi-arrow-down green-text`} /> {translate('receipt-and-low', 'physical-confirmation')}
                            </div>
                    </div> 
                }
            /> 
        </>
    );

}

export default (withTranslation()(ButtonsSubtitle));